import { api } from '.';

export function retrieve(payload) {
  return api('/v1/sysconfig/retrieve', payload);
}

export function update(payload) {
  return api('/v1/sysconfig/update', payload);
}
